/* global firebase */

let messaging = null;
let firebaseConfig = null;
let initPromise = null;

/**
 * Initialize Firebase and Messaging
 */
export async function initFirebase() {
	if (messaging) return { messaging, firebaseConfig };

	// If initialization is already in progress, return the existing promise
	if (initPromise) return initPromise;

	initPromise = (async () => {
		try {
			const response = await fetch('/app/themes/wpcore/assets/firebase-config.json');
			if (!response.ok) throw new Error('Failed to load firebase-config.json');

			firebaseConfig = await response.json();

			const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
			messaging = firebase.messaging(app);

			return { messaging, firebaseConfig };
		} catch (error) {
			console.error('Firebase initialization failed:', error);
			initPromise = null;
			return null;
		}
	})();

	return initPromise;
}

/**
 * Get the current messaging instance
 */
export function getMessaging() {
	return messaging;
}

/**
 * Get the current firebase config
 */
export function getFirebaseConfig() {
	return firebaseConfig;
}
